/**
 * Language Provider Helper Component
 * Used to Display Localised Strings
 */
import * as React from 'react';
import {useTranslation} from 'react-i18next';

interface MessageProps {
    id: string;
    defaultValue?: string;
    options?: object;
}

// Injected message
const InjectMassage: React.FunctionComponent<MessageProps> =
    ({id, defaultValue, options = {}}: MessageProps) => {
        const {t} = useTranslation();
        return (<span>{t(id, defaultValue || id, options)}</span>);
    };

export default InjectMassage;
